import { render } from "./Authenticated.vue?vue&type=template&id=7496fbc8&scoped=true"
import script from "./Authenticated.vue?vue&type=script&lang=js"
export * from "./Authenticated.vue?vue&type=script&lang=js"

import "./Authenticated.vue?vue&type=style&index=0&id=7496fbc8&scoped=true&lang=css"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7496fbc8"]])

export default __exports__